import type { RouteRecordRaw } from 'vue-router'
import type { PortfolioWithAssetIdAndYear } from './types'

export interface RouteParams {
    'asset-building-unit.overview': PortfolioWithAssetIdAndYear & {
        building_unit_id: number
    }
}

/**
 * Building unit routes for analytics mode
 */
export const buildingUnitAnalyticsRoutes: RouteRecordRaw[] = [
    {
        path: 'portfolio/:portfolio_id/asset/:asset_id/:reporting_year/building-unit/:building_unit_id',
        component: () => import('@/vue/pages/analytics/building-unit/Layout.vue'),
        children: [
            {
                path: '',
                redirect: { name: 'asset-building-unit.overview' },
            },
            {
                path: 'overview',
                component: () => import('@/vue/pages/building-unit/BuildingUnitOverviewPage.vue'),
                name: 'asset-building-unit.overview',
                meta: {
                    title: 'building-unit.overview',
                    redirectsTo: 'asset.input-portal.building-units',
                    feature: {
                        flag: 'building-units-analytics-page',
                        fallbackRoute: 'asset.overview',
                    },
                },
            },
        ],
    },
]

